import { render, staticRenderFns } from "./UserInfoMini.vue?vue&type=template&id=db68f27c&scoped=true&"
import script from "./UserInfoMini.vue?vue&type=script&lang=ts&"
export * from "./UserInfoMini.vue?vue&type=script&lang=ts&"
import style0 from "./UserInfoMini.vue?vue&type=style&index=0&id=db68f27c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db68f27c",
  null
  
)

export default component.exports